module.exports = __webpack_public_path__ + "static/img/img_m.de669f21.png";